import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit,
    AfterViewInit,
    ViewChild,
    ElementRef,
    QueryList,
    ViewChildren,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    inject
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-segmented-control',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './segmented-control.component.html',
    styleUrl: './segmented-control.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegmentedControlComponent implements OnInit, AfterViewInit {
    @Input() labels: string[] = [];
    @Input() selectedLabel: string = '';

    @Output() selectionChange = new EventEmitter<string>();

    @ViewChild('segmentedControl') segmentedControl!: ElementRef<HTMLDivElement>;
    @ViewChildren('segmentButton') segmentButtons!: QueryList<ElementRef<HTMLButtonElement>>;

    public slidingBackgroundPosition: number = 0;
    public slidingBackgroundWidth: number = 0;
    public slidingBackgroundPositionClass: string = 'single';

    private cdr = inject(ChangeDetectorRef);

    ngOnInit(): void {
        // Select the first label by default if none is selected
        if (this.labels.length > 0 && !this.selectedLabel) {
            this.selectedLabel = this.labels[0];
        }
    }

    ngAfterViewInit(): void {
        // Set initial position of the sliding background
        setTimeout(() => {
            this.updateSlidingBackground();
        }, 100); // Increased delay to ensure DOM is ready
    }

    onSegmentClick(label: string, index: number): void {
        if (this.selectedLabel !== label) {
            this.selectedLabel = label;
            setTimeout(() => {
                this.updateSlidingBackground();
            }, 0);
            this.selectionChange.emit(label);
        }
    }

    private updateSlidingBackground(): void {
        const selectedIndex = this.labels.findIndex(label => label === this.selectedLabel);
        if (selectedIndex >= 0 && this.segmentButtons && this.segmentedControl) {
            const segmentButtonsArray = this.segmentButtons.toArray();
            if (segmentButtonsArray[selectedIndex]?.nativeElement) {
                const selectedButton = segmentButtonsArray[selectedIndex].nativeElement;
                const controlElement = this.segmentedControl.nativeElement;

                // Position to fill the entire segment
                this.slidingBackgroundPosition = selectedButton.offsetLeft;
                this.slidingBackgroundWidth = selectedButton.offsetWidth;

                // Determine position class based on index and total count
                const totalLabels = this.labels.length;
                if (totalLabels === 1) {
                    this.slidingBackgroundPositionClass = 'single';
                } else if (selectedIndex === 0) {
                    this.slidingBackgroundPositionClass = 'first';
                } else if (selectedIndex === totalLabels - 1) {
                    this.slidingBackgroundPositionClass = 'last';
                } else {
                    this.slidingBackgroundPositionClass = 'middle';
                }

                this.cdr.markForCheck();
            }
        }
    }

    isSelected(label: string): boolean {
        return this.selectedLabel === label;
    }

    trackByLabel(index: number, label: string): string {
        return label;
    }

    getTestAttribute(label: string): string {
        return 'segment-' + label.toLowerCase().replace(/\s+/g, '-');
    }
}
